import PageBack from "@/components/PageBack";
import { CUSTOMIZE_HEADER_PAGES, MAIN_PAGES } from "@/constant/Constant";
import MobileAccountInfo from '@/pages/components/MobileAccountInfo';
import {
  Stack,
  Typography
} from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./index.module.css";
import { useSelector } from "react-redux";

const MobileHeader = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { pageTitle } = useSelector(state => state.app);

  const _normalHeader = () => {
    return <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', height: '50px' }}
    >
      <div style={{ position: 'absolute', left: 0, padding: '0 16px' }}>
        <PageBack onClick={() => {
          navigate(-1)
        }} />
      </div>

      <Typography>{pageTitle}</Typography>
    </Stack>;
  }

  const isNormalHeader = () => {
    return MAIN_PAGES.indexOf(location.pathname) === -1 && 
      CUSTOMIZE_HEADER_PAGES.indexOf(location.pathname) === -1;
  }
  
  return (<>
    <Stack direction="row" justifyContent="space-between" className={classes.root}>
      {isNormalHeader() ? _normalHeader() : <MobileAccountInfo />}
    </Stack>
  </>)
}

export default MobileHeader